@if (showContent) {
    <div class="form-master">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <formly-form [form]="form" [fields]="fields" [model]="model" (modelChange)="onModelChange()"> </formly-form>
            <div class="form-actions">
                <button
                    mat-flat-button
                    type="button"
                    color="warn"
                    [disabled]="loading"
                    class="discard-button"
                    (click)="onCancelClick()"
                >
                    {{ discardText }}
                </button>
                @if (canDelete) {
                    <button type="button" class="delete-btn" color="warn" mat-flat-button (click)="onDeleteClick()">
                        {{ deleteText }}
                    </button>
                }
                <button class="submit-button" type="submit" mat-flat-button color="primary" [disabled]="canSave">
                    {{ submitText }}
                </button>
                @if (unsavedChanges) {
                    <span class="unsaved-changes-message">
                        <mat-icon>sync_problem</mat-icon>
                        <small>{{ unsavedText }}</small>
                    </span>
                }
            </div>
        </form>
    </div>
}
